/* eslint-disable react/jsx-no-target-blank */
import { useStyles, Flex } from '@archipro-design/aria';
import * as S from './HeaderSection.style';
import { useProfessionalInitialRouteData } from '@modules/professional/hook/use-professional-initial-route-data';
import { useAppData, useMatchesHandleData } from '@modules/root';
import { useTracker } from '@archipro-website/tracker';
import { useWebsiteReferralTracking } from '~/modules/tracking/util/websiteTracking';
import { useSize } from 'ahooks';
import { useRef } from 'react';
import { trackEnquireReveal } from '~/modules/tracking/util/trackEnquireReveal';
import type { HeaderSectionProps } from './HeaderSection';
import BookProfessional from '@modules/professional/component/header-section/BookProfessional';
import { TileFollowButton } from '@rocco/ui/tile-shared/components/TileFollowButton';

import { PrimaryCtaEnum } from '../../../../../generated/graphql';
import { Button as RoccoButton } from '@rocco/components/button';

const RightHeaderActionLinkDesktop = ({
    primaryCTA,
    isEnquiryOpen,
    onEnquiryModalOpenChange,
    openEnquiryModal,
}: Pick<HeaderSectionProps, 'primaryCTA'> & {
    isEnquiryOpen: boolean;
    onEnquiryModalOpenChange: (isOpen: boolean) => void;
    openEnquiryModal: (changeUrl?: boolean) => void;
}) => {
    const professional = useProfessionalInitialRouteData();
    const { ID, Title, Website, TeamCalendarURLSegment } = professional;
    const isBMPreview = useMatchesHandleData('isBMPreview', false);
    const tracker = useTracker();

    const {
        referralTrackingURL,
        referralTrackingClass,
        referralTrackingParams,
    } = useWebsiteReferralTracking(Website, {
        libraryItemID: professional.ID,
        professionalTitle: professional.Title,
    });

    const innerRef = useRef<HTMLDivElement>(null);
    const innerSize = useSize(innerRef);

    const { css } = useStyles({ innerHeight: innerSize?.height, isBMPreview });

    const { bookConsultationEnabled } = useAppData();
    const showBookConsultation =
        TeamCalendarURLSegment &&
        bookConsultationEnabled &&
        professional.primaryCTA?.primaryCTA === PrimaryCtaEnum.BookConsultation;

    return (
        <>
            {referralTrackingURL ? (
                <RoccoButton color="secondary" disabled={isBMPreview} asChild>
                    <a
                        href={referralTrackingURL}
                        target="_blank"
                        {...referralTrackingParams}
                        className={referralTrackingClass}
                        data-testid="website-link"
                    >
                        Visit Website
                    </a>
                </RoccoButton>
            ) : null}
            <Flex className={css(S.EnquiryAndSaveWrapper)}>
                {showBookConsultation ? (
                    <BookProfessional
                        isEnquiryOpen={isEnquiryOpen}
                        onEnquiryModalOpenChange={onEnquiryModalOpenChange}
                        openEnquiryModal={openEnquiryModal}
                        professional={professional}
                        enquiryType={'professional'}
                    />
                ) : (
                    <>
                        <RoccoButton
                            color="primary"
                            disabled={isBMPreview}
                            onClick={() => {
                                openEnquiryModal();
                                trackEnquireReveal(tracker, {
                                    professionalName: Title,
                                    itemID: ID,
                                    itemType: 'professional',
                                    source: 'EnquiryModal',
                                });
                            }}
                        >
                            {primaryCTA.primaryCTALabel}
                        </RoccoButton>

                        <TileFollowButton
                            pinId={ID}
                            pinType="ProfessionalPin"
                            color={'secondary'}
                            disabled={isBMPreview}
                        />
                    </>
                )}
            </Flex>
        </>
    );
};

export default RightHeaderActionLinkDesktop;
